export default "__VITE_ASSET__BUalnfen__"